import { cn } from "@/shared/utils";
import { ComponentProps } from "react";

const Divider = ({ className, ...props }: ComponentProps<"div">) => {
  return (
    <div className={cn("h-px bg-[#FBC76C] w-full", className)} {...props} />
  );
};

export default Divider;
